import { Experiment } from '@ms/yammer-data/dist/state/types';
import { useIsAskMeAnythingEnabled } from '@ms/yammer-hooks/dist/askMeAnything';
import { useExperimentTreatmentWithoutReporting } from '@ms/yammer-hooks/dist/experiments';

import { UseUIFeatureCheck } from '../types';

export const useAreAMACoorganizersEnabled: UseUIFeatureCheck = () => {
  const isAMAEnabled = useIsAskMeAnythingEnabled();
  const amaCoorganizersExperiment = useExperimentTreatmentWithoutReporting(Experiment.VivaEngageAmaCoorganizers);

  return isAMAEnabled && amaCoorganizersExperiment === true;
};

export const useAreAMAEventsEnabled: UseUIFeatureCheck = () => useIsAskMeAnythingEnabled();

export const useIsAMACreationV2Enabled: UseUIFeatureCheck = () => {
  const isAMAEnabled = useIsAskMeAnythingEnabled();
  const amaCreationV2Experiment = useExperimentTreatmentWithoutReporting(Experiment.VivaEngageAmaCreationV2);

  return isAMAEnabled && amaCreationV2Experiment === true;
};
